// extracted by mini-css-extract-plugin
module.exports = {"orderStatusPage":"OrderStatusPage_orderStatusPage__2tUH9","orderStatusBlock":"OrderStatusPage_orderStatusBlock__3gDWv"};